import { useTranslation } from 'react-i18next';
import { Link } from '@/lib/router-compat';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center">
      <span className="iconify lucide--map-pin-off text-base-content/40 size-10" />
      <h1 className="text-xl font-semibold">{t('notFound.title')}</h1>
      <p className="text-base-content/60">{t('notFound.description')}</p>
      <Link to="/" className="btn btn-primary btn-sm mt-2">
        {t('notFound.back')}
      </Link>
    </div>
  );
}
